<div
  class="m-confidence-interval-slider flex flex-col items-center gap-[3px] w-full">
  <!-- Custom Slider Track -->
  <div class="w-full h-3 flex items-center justify-center">
    <!-- Background track -->
    <div class="w-full h-1.5 bg-gray-300 rounded-[0.25rem] relative">
      <!-- Confidence range bar with tooltip -->
      <div
        class="confidence-range absolute rounded-[6px] cursor-pointer"
        [style.background-color]="confidenceBarColor"
        [style.left.%]="getPositionPercentage(data.lowerBound)"
        [style.width]="getCalculatedRangeWidth()"
        [style.height]="getCalculatedRangeHeight()"
        style="top: -3px">
        <!-- Metric value indicator line -->
        <div
          class="absolute w-0.5 bg-gray-1000"
          [style.left.%]="getMetricPositionInRange()"
          [style.height]="getCalculatedRangeHeight()"></div>

        <!-- Tooltip positioned at center of range -->
        <m-tooltip
          [content]="bellCurveTooltipTemplate"
          position="bottom"
          [tooltipOptions]="{
            showDelay: 200,
            hideDelay: 100,
            tooltipStyleClass: 'm-tooltip confidence-interval-tooltip',
          }">
          <div class="absolute inset-0 w-full h-full"></div>
        </m-tooltip>
      </div>
    </div>
  </div>

  <!-- Bounds Display -->
  @if (showLabels) {
    <div class="relative w-full">
      <!-- Metric Value Display -->
      <span
        class="absolute c1 text-gray-1000"
        [style.left.%]="getPositionPercentage(data.metricValue)"
        style="transform: translate(-50%, -200%)">
        {{ formatValue(data.metricValue) }}
      </span>

      <!-- Lower and Upper Bounds -->
      <span
        class="absolute c1 text-gray-1000"
        [style.left.%]="getPositionPercentage(data.lowerBound)"
        style="transform: translateX(-100%)">
        {{ formatValue(data.lowerBound) }}
      </span>
      <span
        class="absolute c1 text-gray-1000"
        [style.left.%]="getPositionPercentage(data.upperBound)"
        style="transform: translateX(0%)">
        {{ formatValue(data.upperBound) }}
      </span>
    </div>
  }
</div>

<!-- Bell Curve Tooltip Template -->
<ng-template #bellCurveTooltipTemplate>
  <m-bell-curve-tooltip
    [metricValue]="tooltipData?.metricValue || ''"
    [lowerBound]="tooltipData?.lowerBound || ''"
    [upperBound]="tooltipData?.upperBound || ''"
    [statisticalSignificance]="tooltipData?.statisticalSignificance || ''">
  </m-bell-curve-tooltip>
</ng-template>
